// extracted by mini-css-extract-plugin
export default {"paperTooltip":"StatusTooltip_paperTooltip__UcY6j","checklistTooltip":"StatusTooltip_checklistTooltip__aOKZO"};